import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import DetailsCard from "./DetailsCard";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Spinner from "../../../../../../utils/Spinner";
import { useParams } from "react-router-dom";
import { TELEMETRY_API } from "../../../../../../constants/serverConfig";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../../../../msalConfig";
import { toast } from "react-toastify";

const DetailsView = (props) => {
  const detaild = props.detaildata;

  const [metricsdata, setmetricsData] = useState([]);
  const [fullscreen, setFullscreen] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [aadgroupFlag, setAADGroupFlag] = useState(false);
  const [oneMonthUserVisitCount, setPastOneMonthUserVisit] = useState("");

  const params = useParams();

  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.graphMe.scopes,
    account: account,
  };

  function handleShow(breakpoint) {
    setFullscreen(breakpoint);
    props.setDetailCardShow(true);
  }

  const METRICS_API = `${TELEMETRY_API}metrics/latest?object_id=${params.id}`;

  const getdetailsmetricsdata = () => {
    setIsFetching(true);
    axios.get(METRICS_API).then((res) => {
      let maindata = res.data;
      let filteriddata = _.filter(
        maindata["metrics"],
        (iddata) => iddata.objectId === `${params.id}`
      );
      let metricsdata = [];
      _.map(filteriddata, (da) => {
        let unixupdatedate = moment.unix(da.batchDate);
        return metricsdata.push({
          metricValue: da.metricValue,
          updatedAt: unixupdatedate.format("MMM D, YYYY"),
        });
      });
      setmetricsData(metricsdata);
      setIsFetching(false);
    });
  };

  const getUserVisitInPastOneMonth = () => {
    axios
      .get(
        TELEMETRY_API + "util/users/count/datasetId?datasetId=" + `${params.id}`
      )
      .then((res) => {
        setPastOneMonthUserVisit(res.data);
      })
      .catch((error) => {
        // toast.error("Error while fetching the past one month user data", {
        //   toastId: "onemonthuserdata",
        //   position: "top-right",
        //   autoClose: 6000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        // });
        console.error(error);
      });
  };

  useEffect(() => {
    const fetchdatasets = async () => {
      try {
        const token = (await instance.acquireTokenSilent(request)).accessToken;
        getdetailsmetricsdata(token);
        getUserVisitInPastOneMonth(token);
      } catch (error) {
        if (error) {
          try {
            const token = (await instance.acquireTokenRedirect(request))
              .accessToken;
            getdetailsmetricsdata(token);
          } catch (error) {}
        }
      }
    };
    fetchdatasets();
  }, [instance]);

  const copyAADgroups = (value) => {
    setAADGroupFlag(true);
    navigator.clipboard.writeText(value);

    setTimeout(() => setAADGroupFlag(false), 2000);
  };
  return (
    <>
      {/* <Button onClick={handleShow} className="details__view">
        Details
      </Button> */}
      <Modal
        show={props.detailCardshow}
        fullscreen={fullscreen}
        onHide={() => props.setDetailCardShow(false)}
        className="modal right "
      >
        <Modal.Header closeButton className="detail-modal">
          <h2 className="details__header">Details</h2>
          {aadgroupFlag ? (
            <div className="p-2 rounded aad-group-copy-msg">
              {" "}
              AAD Group Name Copied Successfully!{" "}
            </div>
          ) : (
            ""
          )}
        </Modal.Header>
        <Modal.Body>
          {isFetching ? (
            <div className="justify-content-md-center">
              {" "}
              <Spinner />
            </div>
          ) : (
            <>
              {/* <DetailsCard
                data={detaild}
                metrics={metricsdata}
                oneMonthUserVisitCount={oneMonthUserVisitCount}
                certifiedetails={props.certifiedetails}
                updateCertificationDetails={props.updateCertificationDetails}
                toggleloading={props.toggleloading}
                showModal={props.showModal}
                securityclassification={props.securityclassification}
                sensitivity={props.sensitivity}
                editaccessflag={props.editaccessflag}
                copyAADgroups={copyAADgroups}
              /> */}
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DetailsView;
